import { ApiCreateRentalStock, ApiDeleteRentalStock, ApiGetRentalStockById, ApiGetRentalStockList, ApiGetRentalStockPrice, ApiUpdateRentalStock } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function RentalStockService() {
    const { showFail } = useModal()

    const { fetch: apiGetRentalStockList } = useFetch(ApiGetRentalStockList)
    const { fetch: apiDeleteRentalStock } = useFetch(ApiDeleteRentalStock)
    const { fetch: apiCreateRentalStock } = useFetch(ApiCreateRentalStock)
    const { fetch: apiUpdateRentalStock } = useFetch(ApiUpdateRentalStock)
    const { fetch: apiGetRentalStockById } = useFetch(ApiGetRentalStockById)
    const { fetch: apiGetRentalStockPrice } = useFetch(ApiGetRentalStockPrice)

    const fetchRentalStockList = async (productName, brandId, stockCode, stockStatus, status, pageSize, pageIndex) => {
        const res = await apiGetRentalStockList({
            data: {
                productName, 
                brandId,
                stockCode,
                stockStatus,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteRentalStock = async (rentalStockId, status) => {
        const res = await apiDeleteRentalStock({
            data: {
                rentalStockId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateRentalStock = async (productId, stockIn, purchasePrice, rentalPriceHour, rentalPriceDay, rentalPriceSession, sellingPrice) => {
        const res = await apiCreateRentalStock({
            data: {
                productId,
                stockIn,
                purchasePrice,
                rentalPriceHour,
                rentalPriceDay,
                rentalPriceSession,
                sellingPrice
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchRentalStockById = async (rentalStockId) => {
        const res = await apiGetRentalStockById({
            data: {
                rentalStockId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateRentalStock = async (rentalStockId, productId, stockIn, purchasePrice, rentalPriceHour, rentalPriceDay, rentalPriceSession, sellingPrice) => {
        const res = await apiUpdateRentalStock({
            data: {
                rentalStockId,
                productId,
                stockIn,
                purchasePrice,
                rentalPriceHour,
                rentalPriceDay,
                rentalPriceSession,
                sellingPrice
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchRentalStockPrice = async (productId) => {
        const res = await apiGetRentalStockPrice({
            data: {
                productId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchRentalStockList,
        fetchDeleteRentalStock,
        fetchCreateRentalStock,
        fetchRentalStockById,
        fetchUpdateRentalStock,
        fetchRentalStockPrice
    }
}